import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const env = import.meta.env;
export const ENV = env.VITE_ENV as 'development' | 'staging' | 'production';

export const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY, authDomain: env.VITE_FIREBASE_AUTH_DOMAIN, projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET, appId: env.VITE_FIREBASE_APP_ID,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID, measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
});
if (env.VITE_APPCHECK_SITE_KEY) initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(env.VITE_APPCHECK_SITE_KEY), isTokenAutoRefreshEnabled: true });

export const auth = getAuth(app);
// Offline persistence keeps kiosk/instructor screens usable through Wi-Fi drops.
export const db = initializeFirestore(app, { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) });
export const fns = getFunctions(app, 'europe-west1');
export const storage = getStorage(app);

if (env.VITE_USE_EMULATORS === 'true') {
  if (ENV === 'production') throw new Error('Refusing to start: emulator flag set in a production build.');
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(fns, 'localhost', 5001);
  connectStorageEmulator(storage, 'localhost', 9199);
}

/** Typed callable wrapper. Server errors carry user-facing messages. */
export function call<I, O>(name: string) {
  const fn = httpsCallable<I, O>(fns, name);
  return async (data: I): Promise<O> => (await fn(data)).data;
}
